import { useMemo } from 'react';
import { getClassNames } from '../../../helpers/classHelpers';
import { useSpacing } from '../Grid.helpers';
import { GridElmType, GridElmProps } from '../Grid.types';
import styles from "../Grid.module.scss";

export default function Element<Type extends GridElmType>(props: GridElmProps<Type>) {
    const padding = useSpacing(props, "padding");

    const { grow, min, sticky } = props as GridElmProps<"row">;
    const attributes = useMemo(() => {
        const extra = {
            grow: grow ? "" : undefined,
            sticky: sticky ? "" : undefined,
            min
        };

        return {
            ...extra,
            ...padding.attributes,
            className: getClassNames([
                props.type,
                props.className
            ], styles),
            style: {
                ...props.style,
                ...padding.style,
                background: props.background
            }
        };
    }, [padding, grow, sticky, min, props.type, props.style, props.className, props.background]);

    if (props.type === "sep") return <span {...attributes} />;
    else return <div {...attributes}>{props.children}</div>;
}